module.exports = __webpack_public_path__ + "static/media/profile-avatar.3635837d.svg";